import CryptoJS from "crypto-js";

export const useCrypto = () => {
  const decrypt = (urlSafePayload: string, keyString: string): string => {
    try {
      let standardBase64 = urlSafePayload.replace(/-/g, "+").replace(/_/g, "/");

      while (standardBase64.length % 4 !== 0) {
        standardBase64 += "=";
      }

      const rawData = CryptoJS.enc.Base64.parse(standardBase64);
      if (rawData.sigBytes < 16) return "";

      const iv = CryptoJS.lib.WordArray.create(rawData.words.slice(0, 4), 16);
      const ciphertext = CryptoJS.lib.WordArray.create(
        rawData.words.slice(4),
        rawData.sigBytes - 16,
      );

      const key = CryptoJS.enc.Hex.parse(keyString);

      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: ciphertext } as any,
        key,
        { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 },
      );

      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

      if (!decryptedText) {
        console.warn(
          "Decryption succeeded but resulted in empty or non-UTF8 string (Likely a key mismatch).",
        );
        return "";
      }

      return decryptedText;
    } catch (error) {
      console.error("Decryption failed runtime error:", error);
      return "";
    }
  };

  const encrypt = (plaintext: string, keyString: string): string => {
    try {
      // 🛠️ FIX: Parse as Hex instead of UTF-8
      const key = CryptoJS.enc.Hex.parse(keyString);

      const iv = CryptoJS.lib.WordArray.random(16);

      const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      const ciphertext = encrypted.ciphertext;
      const ivAndCiphertext = iv.concat(ciphertext);

      return CryptoJS.enc.Base64.stringify(ivAndCiphertext);
    } catch (error) {
      console.error("Encryption failed:", error);
      return "";
    }
  };

  return {
    encrypt,
    decrypt,
  };
};
